import { GET, POST } from "./fetch-auth-action";
import forge from "node-forge";
const backUrl = process.env.REACT_APP_BACK_BASE_URL;

const isHttpsContext = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location && window.location.protocol === "https:";
};

const hasWebCrypto = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return Boolean(window.crypto && window.crypto.subtle);
};

const pemToArrayBuffer = (pem) => {
  const cleaned = pem.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s+/g, "");
  const binary = window.atob(cleaned);
  const buffer = new ArrayBuffer(binary.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binary.length; i += 1) {
    view[i] = binary.charCodeAt(i);
  }
  return buffer;
};

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

const encryptWithWebCrypto = async (publicKeyPem, plaintext) => {
  const keyData = pemToArrayBuffer(publicKeyPem);
  const cryptoKey = await window.crypto.subtle.importKey(
    "spki",
    keyData,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
  const encoded = new TextEncoder().encode(plaintext);
  const encrypted = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);
  return arrayBufferToBase64(encrypted);
};

const encryptWithForge = (publicKeyPem, plaintext) => {
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encrypted = publicKey.encrypt(forge.util.encodeUtf8(plaintext), "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha256.create(),
    },
  });
  return forge.util.encode64(encrypted);
};

const normalizePublicKeyPem = (publicKey) => {
  const trimmed = publicKey.trim();
  if (trimmed.includes("BEGIN PUBLIC KEY")) {
    return trimmed;
  }
  const cleaned = trimmed.replace(/\s+/g, "");
  const lines = cleaned.match(/.{1,64}/g);
  const body = lines ? lines.join("\n") : cleaned;
  return `-----BEGIN PUBLIC KEY-----\n${body}\n-----END PUBLIC KEY-----`;
};

const encryptPassword = async (publicKeyPem, password) => {
  if (isHttpsContext() && hasWebCrypto()) {
    try {
      return await encryptWithWebCrypto(publicKeyPem, password);
    } catch (error) {
      return encryptWithForge(normalizePublicKeyPem(publicKeyPem), password);
    }
  }

  return encryptWithForge(normalizePublicKeyPem(publicKeyPem), password);
};
 
const createTokenHeader = (token) => {
  return {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
};
export const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  
  // expirationTime이 이미 타임스탬프인지 확인
  const adjExpirationTime = typeof expirationTime === 'number' 
    ? expirationTime 
    : new Date(expirationTime).getTime();
  
  return adjExpirationTime - currentTime;
};
export const loginTokenHandler = (token, expirationTime) => {

  // 백엔드에서 받은 값 그대로 저장
  localStorage.setItem("token", token);
  localStorage.setItem("expirationTime", expirationTime);

  const remainingTime = calculateRemainingTime(expirationTime);
  
  localStorage.setItem("remainingTime", remainingTime);
  return remainingTime;
};
export const retrieveStoredToken = () => {
  const storedToken = localStorage.getItem("token");
  const storedExpirationDate = localStorage.getItem("expirationTime") || "0";
  const remaingTime = calculateRemainingTime(+storedExpirationDate);

  if (remaingTime <= 1000) {
    localStorage.removeItem("token");
    localStorage.removeItem("expirationTime");
    localStorage.removeItem("remainingTime");
    return null;
  }
  return {
    token: storedToken,
    duration: remaingTime,
  };
};
export const signupActionHandler = (email, password, nickname) => {
  const URL = backUrl + "/api/auth/signup";
  const signupObject = { email, password, nickname };
  const response = POST(URL, signupObject, {});
  return response;
};

export const loginActionHandler = async (email, password) => {
  const URL = backUrl + "/api/auth/login";

  // 1. 공개키 요청
  const { publicKey } = await fetch(backUrl + "/api/auth/public-key").then(res => res.json());

  // 2. 비밀번호 암호화
  const encryptedPassword = await encryptPassword(publicKey, password);

  if (!encryptedPassword) {
    throw new Error("비밀번호 암호화 실패");
  }

  // 3. 암호화된 비밀번호 전송
  const loginObject = { email, password: encryptedPassword };
  const response = await POST(URL, loginObject, {});
  return response;
};

export const logoutActionHandler = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expirationTime");
  localStorage.removeItem("remainingTime");
};
export const getUserActionHandler = (token) => {
  const URL = "/api/member/me";
  const response = GET(URL, createTokenHeader(token));
  return response;
};
export const changeNicknameActionHandler = (nickname, token) => {
  const URL = "/api/member/nickname";
  const changeNicknameObj = { nickname };
  const response = POST(URL, changeNicknameObj, createTokenHeader(token));
  return response;
};
export const changePasswordActionHandler = (exPassword, newPassword, token) => {
  const URL = "/api/member/password";
  const changePasswordObj = { exPassword, newPassword };
  const response = POST(URL, changePasswordObj, createTokenHeader(token));
  return response;
};
